import { BoxProps } from '@jfs/ui-new'
import { Colors } from './../../util/util'

const defaultStyles = {
  checkboxStyles: {
    color: Colors.PRIMARY,
    marginRight: 0,
    marginTop: 0,
    // alignSelf: 'center',
  } as BoxProps,
  disabledStyle: {
    color: Colors.GREY_SHADE,
    marginRight: 0,
    alignSelf: 'center',
    marginTop: 0,
  } as BoxProps,
  container: { flexDirection: 'row', alignItems: 'center' } as BoxProps,
}

export const styles = {
  DEFAULT: {
    ...defaultStyles,
  },
  NOTIFICATION: {
    ...defaultStyles,
    checkboxStyles: {
      ...defaultStyles.checkboxStyles,
      marginRight: 40,
      marginBottom: 24,
    } as BoxProps,
    disabledStyle: {
      ...defaultStyles.disabledStyle,
      marginRight: 40,
      marginBottom: 24,
    } as BoxProps,
  },
  WITH_TEXT: {
    ...defaultStyles,
    checkboxStyles: {
      ...defaultStyles.checkboxStyles,
      minWidth: 160,
      marginRight: 64,
    } as BoxProps,
    disabledStyle: {
      ...defaultStyles.disabledStyle,
      minWidth: 160,
      marginRight: 64,
    } as BoxProps,
  },
  ROUNDED: {
    ...defaultStyles,
    checkboxStyles: {
      ...defaultStyles.checkboxStyles,
      marginTop: -3,
    } as BoxProps,
    disabledStyle: {
      ...defaultStyles.disabledStyle,
      marginTop: -3,
    } as BoxProps,
  },
  WITH_TEXT_NO_PADDING: {
    ...defaultStyles,
    checkboxStyles: {
      ...defaultStyles.checkboxStyles,
      height: 40,
    } as BoxProps,
  },
  CHECK_LIST: {
    ...defaultStyles,
    container: { flexDirection: 'row', alignItems: 'center', pv: 5 } as BoxProps,
    checkboxStyles: {
      ...defaultStyles.checkboxStyles,
      marginRight: 38,
    } as BoxProps,
    disabledStyle: {
      ...defaultStyles.disabledStyle,
      marginRight: 38,
    } as BoxProps,
  },
  FORM_HORIZONTAL: {
    ...defaultStyles,
    container: { flexDirection: 'row', alignItems: 'center', marginTop: 30 } as BoxProps,
  },
}
